import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReaction = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.25005 7.02421L4.77422 2.96962C4.72744 2.84104 4.70644 2.70449 4.71242 2.56779C4.71841 2.43109 4.75126 2.29691 4.8091 2.1729C4.92592 1.92246 5.13745 1.72869 5.39714 1.63421C5.65683 1.53972 5.94342 1.55227 6.19385 1.66909C6.44429 1.78591 6.63807 1.99743 6.73255 2.25712L8.1988 6.28545",
			stroke: "#71717A",
			strokeWidth: 1.1,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.19832 6.285L6.87499 2.64833C6.82821 2.51975 6.80721 2.3832 6.81319 2.2465C6.81918 2.1098 6.85203 1.97562 6.90987 1.85161C6.96772 1.72761 7.04942 1.61621 7.15031 1.52378C7.25121 1.43135 7.36932 1.3597 7.49791 1.31292C7.62649 1.26613 7.76303 1.24513 7.89973 1.25112C8.03644 1.2571 8.17062 1.28996 8.29462 1.3478C8.41863 1.40564 8.53003 1.48734 8.62246 1.58824C8.71489 1.68913 8.78654 1.80725 8.83332 1.93583L10.6917 7.04458",
			stroke: "#71717A",
			strokeWidth: 1.1,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.24999 7.02377L5.36457 4.59127C5.27869 4.34036 5.10375 4.12967 4.87291 3.99912C4.64207 3.86857 4.37136 3.82723 4.11207 3.88293C3.97055 3.91841 3.83806 3.98322 3.72318 4.07317C3.6083 4.16312 3.5136 4.2762 3.44521 4.40508C3.37682 4.53396 3.33627 4.67577 3.32618 4.82133C3.31609 4.96688 3.3367 5.11293 3.38666 5.25002L5.54874 11.19C5.55625 11.2106 5.55707 11.2331 5.55107 11.2542C5.54508 11.2753 5.53258 11.2939 5.51536 11.3075C5.49813 11.3211 5.47706 11.3289 5.45515 11.3298C5.43324 11.3307 5.4116 11.3246 5.39332 11.3125L3.05041 9.76585L2.40249 9.33835C2.17679 9.20488 1.90898 9.16163 1.65274 9.21727C1.3965 9.27291 1.17074 9.42332 1.02072 9.63838C0.870689 9.85343 0.807471 10.1172 0.843731 10.3769C0.87999 10.6366 1.01305 10.873 1.21624 11.0388L6.63041 15.9275C6.65041 15.9438 6.67207 15.9579 6.69332 15.9729",
			stroke: "#71717A",
			strokeWidth: 1.1,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 4.56668L11.5229 3.23668C11.437 2.98568 11.262 2.77493 11.0311 2.64437C10.8002 2.51381 10.5293 2.47253 10.27 2.52834C10.1285 2.56383 9.99608 2.62863 9.88123 2.71855C9.76639 2.80847 9.67172 2.9215 9.60333 3.05034C9.53495 3.17917 9.49438 3.32093 9.48426 3.46643C9.47414 3.61194 9.49469 3.75795 9.54458 3.89501L10.6917 7.04626",
			stroke: "#71717A",
			strokeWidth: 1.1,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.7988 9.40837L14.6226 4.06712C14.7531 3.8255 14.9738 3.64521 15.2366 3.56548C15.4995 3.48576 15.7831 3.51306 16.0259 3.64143C16.2687 3.7698 16.451 3.98886 16.5331 4.25095C16.6152 4.51303 16.5904 4.79693 16.4642 5.04087L13.6405 10.3821",
			stroke: "#71717A",
			strokeWidth: 1.1,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6404 10.3817L16.2695 5.40874C16.4001 5.16711 16.6208 4.98682 16.8836 4.9071C17.1464 4.82737 17.4301 4.85467 17.6729 4.98304C17.9157 5.11141 18.098 5.33048 18.18 5.59256C18.2621 5.85465 18.2374 6.13855 18.1112 6.38249L15.482 11.3554",
			stroke: "#71717A",
			strokeWidth: 1.1,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.4821 11.3554L17.1375 8.22457C17.2056 8.09562 17.3001 7.98243 17.4148 7.8923C17.5294 7.80218 17.6618 7.73714 17.8032 7.7014C17.9446 7.66566 18.0919 7.66001 18.2356 7.68481C18.3793 7.70962 18.5162 7.76433 18.6375 7.8454C18.8528 8.00053 19.0036 8.22927 19.0615 8.48825C19.1193 8.74723 19.0801 9.01843 18.9512 9.2504L15.2791 16.1971C14.7853 17.129 13.998 17.8722 13.0391 18.3115C12.0802 18.7508 11.0033 18.8617 9.97496 18.627C8.94667 18.3924 8.02443 17.8253 7.35102 17.0135C6.67762 16.2017 6.29063 15.1906 6.24998 14.1367V6.84249C6.24126 6.58288 6.32985 6.32937 6.49838 6.1317C6.6669 5.93403 6.9032 5.80646 7.16093 5.77401C7.41865 5.74156 7.6792 5.80657 7.89147 5.9563C8.10374 6.10602 8.2524 6.32965 8.30831 6.58332L8.42581 7.34999L8.85206 10.1242C8.85539 10.1458 8.86546 10.1658 8.88083 10.1814C8.8962 10.197 8.91609 10.2074 8.93768 10.211C8.95927 10.2147 8.98145 10.2114 9.00109 10.2017C9.02073 10.192 9.03681 10.1764 9.04706 10.1571L12 4.56665C12.0681 4.43771 12.1626 4.32451 12.2773 4.23439C12.3919 4.14426 12.5243 4.07923 12.6657 4.04348C12.8071 4.00774 12.9544 4.00209 13.0981 4.0269C13.2418 4.0517 13.3787 4.10641 13.5 4.18749C13.7154 4.34262 13.8663 4.57145 13.9242 4.83052C13.982 5.0896 13.9427 5.36089 13.8137 5.5929L11.7966 9.4079",
			stroke: "#71717A",
			strokeWidth: 1.1,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgReaction);
export default ForwardRef;
